module.exports = __webpack_public_path__ + "static/img/banner_solutions_ic.10d3da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_ic.png
// module id = ZAGw
// module chunks = 10